module.exports = __webpack_public_path__ + "static/media/LSUV.5ba47df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuotePage/TransferOptionsPanel/images/LSUV.svg
// module id = 858
// module chunks = 0